export default __webpack_public_path__ + "static/media/highlight_expert_1.646d56b2.svg";